enum CollectionStatus {
  DRAFT = 'draft',
  AWAITING_SUGGESTIONS = 'awaitingSuggestions',
  REVIEW_SUGGESTIONS = 'reviewSuggestions',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}
export default CollectionStatus;
